import { useQuery } from '@tanstack/react-query';
import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { meQueryOptions } from '@/queries/meQuery/meQuery';
import { assertCondition } from '@/utils/typescript';

const WithdrawalNotPossible = ({ confirmAction }: ModalProps) => {
  const { data: me } = useQuery(meQueryOptions());
  const { t } = useTranslation('Modal');

  if (!me) {
    return null;
  }

  assertCondition(!!me.activatedProducts.credit);

  return (
    <Modal title={t('WithdrawalNotPossible.title')}>
      <p>
        {t('WithdrawalNotPossible.info', {
          minimumWithdrawalAmount: me.activatedProducts.credit.minimumWithdrawalAmount,
        })}
      </p>
      <ModalActions>
        <Button onClick={confirmAction}>{t('WithdrawalNotPossible.button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default WithdrawalNotPossible;
